import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: ReactNode;
  /** Trailing actions in the header (buttons, toggles…). */
  actions?: ReactNode;
  variant?: 'default' | 'flat' | 'well';
  /** Remove body padding (e.g. to hold a flush table). */
  flushBody?: boolean;
  children?: ReactNode;
}

/** Base container: optional title + actions header, then body (brief §4.2). */
export function Card({ title, actions, variant = 'default', flushBody, className, children, ...rest }: CardProps) {
  return (
    <section
      className={cx('tc-card', variant === 'flat' && 'tc-card--flat', variant === 'well' && 'tc-card--well', className)}
      {...rest}
    >
      {(title || actions) && (
        <header className="tc-card__head">
          {title ? <h2 className="tc-card__title">{title}</h2> : <span />}
          {actions ? <div className="tc-card__actions">{actions}</div> : null}
        </header>
      )}
      <div className={cx('tc-card__body', flushBody && 'tc-card__body--flush')}>{children}</div>
    </section>
  );
}
